module.exports = __webpack_public_path__ + "img/232.bae6ec87.jpg";